import { render, staticRenderFns } from "./ShiftSegmentScheduleTypeTag.vue?vue&type=template&id=50ec7546&"
import script from "./ShiftSegmentScheduleTypeTag.vue?vue&type=script&lang=js&"
export * from "./ShiftSegmentScheduleTypeTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports